import { ApiRoutes } from '@gr/core/api-routes';
import type { BlogRole, CreateBlogRequestDto, MemberDto, MyBlogDto, UpdateBlogRequestDto } from '@gr/core/accounts/workspaces/dto';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient } from '../../../shared/http/http-client';

export class WorkspacesApi {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<OperationResult<MyBlogDto[]>> {
    return this.http.get(ApiRoutes.blogs.list);
  }
  create(input: CreateBlogRequestDto): Promise<OperationResult<MyBlogDto>> {
    return this.http.post(ApiRoutes.blogs.list, input);
  }
  get(blogId: string): Promise<OperationResult<MyBlogDto>> {
    return this.http.get(ApiRoutes.blogs.byId(blogId));
  }
  update(blogId: string, input: UpdateBlogRequestDto): Promise<OperationResult<MyBlogDto>> {
    return this.http.patch(ApiRoutes.blogs.byId(blogId), input);
  }
  members(blogId: string): Promise<OperationResult<MemberDto[]>> {
    return this.http.get(ApiRoutes.blogs.members(blogId));
  }
  addMember(blogId: string, login: string, role: BlogRole): Promise<OperationResult<MemberDto[]>> {
    return this.http.post(ApiRoutes.blogs.members(blogId), { login, role });
  }
  updateMember(blogId: string, userId: string, role: BlogRole): Promise<OperationResult<MemberDto[]>> {
    return this.http.patch(ApiRoutes.blogs.member(blogId, userId), { role });
  }
  removeMember(blogId: string, userId: string): Promise<OperationResult<MemberDto[]>> {
    return this.http.delete(ApiRoutes.blogs.member(blogId, userId));
  }
}
